<template>
  <div class="absolute z-10 h-full w-full bg-white/40" />
</template>

<script setup></script>
